import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { configRoutes } from "./config";
import { RestrictedRoute } from "./restricted-route";
import { MainLayout } from "../layouts/main";
import SMART_RETAIL_ERROR from "../pages/smart-retail-error";


function SideEffectScrollUpToTopOnLocationChange() {
  // This is a side-effect-only components that does not render anything.
  useEffect(
    () => {
      window.scrollTo(0, 0);

      const topElem = document.getElementById("i-m-top");

      if (topElem) {
        topElem.scrollIntoView();
      }
    },
    [useLocation()]
  );

  return null;
}

export const Router: React.FC = () => (
  <BrowserRouter>
    <SideEffectScrollUpToTopOnLocationChange />
    <Routes>
      {
          configRoutes.map(
            ({ appRoutes, isPrivate }) => appRoutes.map(
              ({ children, path, layout, restricted }) => (
                  <Route
                    key={path}
                    path={path}
                    element={
                      <RestrictedRoute
                        restricted={restricted}
                        isPrivate={isPrivate}
                        layout={layout}
                      >
                        {
                          layout
                            ? <MainLayout>{children}</MainLayout>
                            : children
                        }
                      </RestrictedRoute>
                    }
                  >
                  </Route>
              )
            )
          )
      }
      <Route
        path="*"
        element={<SMART_RETAIL_ERROR error_message="campaign_error"/>}
      />
    </Routes>
  </BrowserRouter>
);
